export default ['SX0103M','SX0104M','SX0106','SX0108','SX01P3','SX01P6','SX01P6B','SX03P8','SX1106','SX1108','SX1801']